module.exports = __webpack_public_path__ + "media/bg.e99875d6.mp4";